import { cn } from "@/lib/utils";

import { formatDuration, RESPONSE_TARGET_SECONDS } from "./leadUtils";

/** Zeit bis zum Erstkontakt; über dem Ziel von 60 Sekunden rot. */
export const ResponseTime = ({ seconds }: { seconds?: number | null }) => (
  <span
    className={cn(
      "tabular-nums",
      seconds != null && seconds > RESPONSE_TARGET_SECONDS
        ? "text-destructive"
        : "text-foreground",
    )}
  >
    {formatDuration(seconds)}
  </span>
);
